import script from "./MovieDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MovieDetails.vue?vue&type=script&setup=true&lang=js"

import "./MovieDetails.vue?vue&type=style&index=0&id=28242110&lang=scss"

const __exports__ = script;

export default __exports__